import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.object.to-string.js";
// src/index.tsx
import { useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";
var getScrollParent = function getScrollParent(node) {
  var parent = node;
  while (parent = parent.parentElement) {
    var overflowYVal = getComputedStyle(parent, null).getPropertyValue("overflow-y");
    if (parent === document.body) return window;
    if (overflowYVal === "auto" || overflowYVal === "scroll") return parent;
  }
  return window;
};
var isOffsetElement = function isOffsetElement(el) {
  return el.firstChild ? el.firstChild.offsetParent === el : true;
};
var offsetTill = function offsetTill(node, target) {
  var current = node;
  var offset = 0;
  if (!isOffsetElement(target)) {
    offset += node.offsetTop - target.offsetTop;
    target = node.offsetParent;
    offset += -node.offsetTop;
  }
  do {
    offset += current.offsetTop;
    current = current.offsetParent;
  } while (current && current !== target);
  return offset;
};
var getParentNode = function getParentNode(node) {
  var currentParent = node.parentElement;
  while (currentParent) {
    var style = getComputedStyle(currentParent, null);
    if (style.getPropertyValue("display") !== "contents") break;
    currentParent = currentParent.parentElement;
  }
  return currentParent || window;
};
var stickyProp = null;
if (typeof CSS !== "undefined" && CSS.supports) {
  if (CSS.supports("position", "sticky")) stickyProp = "sticky";else if (CSS.supports("position", "-webkit-sticky")) stickyProp = "-webkit-sticky";
}
var passiveArg = false;
try {
  var opts = Object.defineProperty({}, "passive", {
    // eslint-disable-next-line getter-return
    get: function get() {
      passiveArg = {
        passive: true
      };
    }
  });
  var emptyHandler = function emptyHandler() {};
  window.addEventListener("testPassive", emptyHandler, opts);
  window.removeEventListener("testPassive", emptyHandler, opts);
} catch (e) {}
var getDimensions = function getDimensions(opts) {
  var el = opts.el,
    onChange = opts.onChange,
    unsubs = opts.unsubs,
    measure = opts.measure;
  if (el === window) {
    var getRect = function getRect() {
      return {
        top: 0,
        left: 0,
        height: window.innerHeight,
        width: window.innerWidth
      };
    };
    var mResult = measure(getRect());
    var handler = function handler() {
      Object.assign(mResult, measure(getRect()));
      onChange();
    };
    window.addEventListener("resize", handler, passiveArg);
    unsubs.push(function () {
      return window.addEventListener("resize", handler, passiveArg);
    });
    return mResult;
  } else {
    var _mResult = measure(el.getBoundingClientRect());
    var _handler = function _handler() {
      Object.assign(_mResult, measure(el.getBoundingClientRect()));
      onChange();
    };
    var ro = new ResizeObserver(_handler);
    ro.observe(el);
    unsubs.push(function () {
      return ro.disconnect();
    });
    return _mResult;
  }
};
var getVerticalPadding = function getVerticalPadding(node) {
  var computedParentStyle = getComputedStyle(node, null);
  var parentPaddingTop = parseInt(computedParentStyle.getPropertyValue("padding-top"), 10);
  var parentPaddingBottom = parseInt(computedParentStyle.getPropertyValue("padding-bottom"), 10);
  return {
    top: parentPaddingTop,
    bottom: parentPaddingBottom
  };
};
var setup = function setup(node, unsubs, opts) {
  var bottom = opts.bottom,
    offsetBottom = opts.offsetBottom,
    offsetTop = opts.offsetTop;
  var scrollPane = getScrollParent(node);
  var isScheduled = false;
  var scheduleOnLayout = function scheduleOnLayout() {
    if (!isScheduled) {
      requestAnimationFrame(function () {
        var nextMode = onLayout();
        if (nextMode !== mode) changeMode(nextMode);
        isScheduled = false;
      });
    }
    isScheduled = true;
  };
  var latestScrollY = scrollPane === window ? window.scrollY : scrollPane.scrollTop;
  var isBoxTooLow = function isBoxTooLow(scrollY) {
    var scrollPaneOffset = scrollPaneDims.offsetTop,
      viewPortHeight = scrollPaneDims.height;
    var naturalTop = parentDims.naturalTop;
    var nodeHeight = nodeDims.height;
    if (scrollY + scrollPaneOffset + viewPortHeight >= naturalTop + nodeHeight + relativeOffset + offsetBottom) {
      return true;
    }
    return false;
  };
  var onLayout = function onLayout() {
    var viewPortHeight = scrollPaneDims.height;
    var nodeHeight = nodeDims.height;
    if (nodeHeight + offsetTop + offsetBottom <= viewPortHeight) {
      return 3 /* small */;
    } else {
      if (isBoxTooLow(latestScrollY)) {
        return 1 /* stickyBottom */;
      } else {
        return 2 /* relative */;
      }
    }
  };

  var scrollPaneIsOffsetEl = scrollPane !== window && isOffsetElement(scrollPane);
  var scrollPaneDims = getDimensions({
    el: scrollPane,
    onChange: scheduleOnLayout,
    unsubs: unsubs,
    measure: function measure(_ref) {
      var height = _ref.height,
        top = _ref.top;
      return {
        height: height,
        offsetTop: scrollPaneIsOffsetEl ? top : 0
      };
    }
  });
  var parentNode = getParentNode(node);
  var parentPaddings = parentNode === window ? {
    top: 0,
    bottom: 0
  } : getVerticalPadding(parentNode);
  var parentDims = getDimensions({
    el: parentNode,
    onChange: scheduleOnLayout,
    unsubs: unsubs,
    measure: function measure(_ref2) {
      var height = _ref2.height;
      return {
        height: height - parentPaddings.top - parentPaddings.bottom,
        naturalTop: parentNode === window ? 0 : offsetTill(parentNode, scrollPane) + parentPaddings.top + scrollPaneDims.offsetTop
      };
    }
  });
  var nodeDims = getDimensions({
    el: node,
    onChange: scheduleOnLayout,
    unsubs: unsubs,
    measure: function measure(_ref3) {
      var height = _ref3.height;
      return {
        height: height
      };
    }
  });
  var relativeOffset = 0;
  var mode = onLayout();
  var changeMode = function changeMode(newMode) {
    var prevMode = mode;
    mode = newMode;
    if (prevMode === 2 /* relative */) relativeOffset = -1;
    if (newMode === 3 /* small */) {
      node.style.position = stickyProp;
      if (bottom) {
        node.style.bottom = "".concat(offsetBottom, "px");
      } else {
        node.style.top = "".concat(offsetTop, "px");
      }
      return;
    }
    var viewPortHeight = scrollPaneDims.height,
      scrollPaneOffset = scrollPaneDims.offsetTop;
    var parentHeight = parentDims.height,
      naturalTop = parentDims.naturalTop;
    var nodeHeight = nodeDims.height;
    if (newMode === 2 /* relative */) {
      node.style.position = "relative";
      relativeOffset = prevMode === 0 /* stickyTop */ ? Math.max(0, scrollPaneOffset + latestScrollY - naturalTop + offsetTop) : Math.max(0, scrollPaneOffset + latestScrollY + viewPortHeight - (naturalTop + nodeHeight + offsetBottom));
      if (bottom) {
        var nextBottom = Math.max(0, parentHeight - nodeHeight - relativeOffset);
        node.style.bottom = "".concat(nextBottom, "px");
      } else {
        node.style.top = "".concat(relativeOffset, "px");
      }
    } else {
      node.style.position = stickyProp;
      if (newMode === 1 /* stickyBottom */) {
        if (bottom) {
          node.style.bottom = "".concat(offsetBottom, "px");
        } else {
          node.style.top = "".concat(viewPortHeight - nodeHeight - offsetBottom, "px");
        }
      } else {
        if (bottom) {
          node.style.bottom = "".concat(viewPortHeight - nodeHeight - offsetBottom, "px");
        } else {
          node.style.top = "".concat(offsetTop, "px");
        }
      }
    }
  };
  changeMode(mode);
  var onScroll = function onScroll(scrollY) {
    if (scrollY === latestScrollY) return;
    var scrollDelta = scrollY - latestScrollY;
    latestScrollY = scrollY;
    if (mode === 3 /* small */) return;
    var scrollPaneOffset = scrollPaneDims.offsetTop,
      viewPortHeight = scrollPaneDims.height;
    var naturalTop = parentDims.naturalTop,
      parentHeight = parentDims.height;
    var nodeHeight = nodeDims.height;
    if (scrollDelta > 0) {
      if (mode === 0 /* stickyTop */) {
        if (scrollY + scrollPaneOffset + offsetTop > naturalTop) {
          var topOffset = Math.max(0, scrollPaneOffset + latestScrollY - naturalTop + offsetTop);
          if (scrollY + scrollPaneOffset + viewPortHeight <= naturalTop + nodeHeight + topOffset + offsetBottom) {
            changeMode(2 /* relative */);
          } else {
            changeMode(1 /* stickyBottom */);
          }
        }
      } else if (mode === 2 /* relative */) {
        if (isBoxTooLow(scrollY)) changeMode(1 /* stickyBottom */);
      }
    } else {
      if (mode === 1 /* stickyBottom */) {
        if (scrollPaneOffset + scrollY + viewPortHeight < naturalTop + parentHeight + offsetBottom) {
          var bottomOffset = Math.max(0, scrollPaneOffset + latestScrollY + viewPortHeight - (naturalTop + nodeHeight + offsetBottom));
          if (scrollPaneOffset + scrollY + offsetTop >= naturalTop + bottomOffset) {
            changeMode(2 /* relative */);
          } else {
            changeMode(0 /* stickyTop */);
          }
        }
      } else if (mode === 2 /* relative */) {
        if (scrollPaneOffset + scrollY + offsetTop < naturalTop + relativeOffset) {
          changeMode(0 /* stickyTop */);
        }
      }
    }
  };

  var handleScroll = scrollPane === window ? function () {
    return onScroll(window.scrollY);
  } : function () {
    return onScroll(scrollPane.scrollTop);
  };
  scrollPane.addEventListener("scroll", handleScroll, passiveArg);
  scrollPane.addEventListener("mousewheel", handleScroll, passiveArg);
  unsubs.push(function () {
    return scrollPane.removeEventListener("scroll", handleScroll);
  }, function () {
    return scrollPane.removeEventListener("mousewheel", handleScroll);
  });
};
var useStickyBox = function useStickyBox() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref4$offsetTop = _ref4.offsetTop,
    offsetTop = _ref4$offsetTop === void 0 ? 0 : _ref4$offsetTop,
    _ref4$offsetBottom = _ref4.offsetBottom,
    offsetBottom = _ref4$offsetBottom === void 0 ? 0 : _ref4$offsetBottom,
    _ref4$bottom = _ref4.bottom,
    bottom = _ref4$bottom === void 0 ? false : _ref4$bottom;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    node = _useState2[0],
    setNode = _useState2[1];
  useEffect(function () {
    if (!node || !stickyProp) return;
    var unsubs = [];
    setup(node, unsubs, {
      offsetBottom: offsetBottom,
      offsetTop: offsetTop,
      bottom: bottom
    });
    return function () {
      unsubs.forEach(function (fn) {
        return fn();
      });
    };
  }, [node, offsetBottom, offsetTop, bottom]);
  return setNode;
};
var StickyBox = function StickyBox(props) {
  var offsetTop = props.offsetTop,
    offsetBottom = props.offsetBottom,
    bottom = props.bottom,
    children = props.children,
    className = props.className,
    style = props.style;
  var ref = useStickyBox({
    offsetTop: offsetTop,
    offsetBottom: offsetBottom,
    bottom: bottom
  });
  return /* @__PURE__ */jsx("div", {
    className: className,
    style: style,
    ref: ref,
    children: children
  });
};
var src_default = StickyBox;
export { src_default as default, useStickyBox };